import React, { useState } from 'react';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import { desktopOnly, excludeDesktop } from '../../styles/emotion/mixins/responsive';

import { useEffectOnce } from '../../hooks';

import {
  SharedLoader,
  Promo,
  Primary,
  Secondary,
  Container,
} from './PreauthNavSkeletonLoader.styles';

export type PreauthNavSkeletonLoaderProps = {
  className?: string;
  showSecondaryRow?: boolean;
  /** @deprecated This prop is no longer used within this component and is safe to remove and */
  notDesktop?: boolean;
  showPromoBar?: boolean;
};

const PreauthNavSkeletonLoader = ({
  className,
  showSecondaryRow = false,
  showPromoBar = true,
}: PreauthNavSkeletonLoaderProps): JSX.Element | null => {
  const [isSelfRemoved, setIsSelfRemoved] = useState(false);

  const handleNavRendered = () => {
    if (!isSelfRemoved) setIsSelfRemoved(true);
  };

  useEffectOnce(() => {
    if (typeof window !== 'undefined') {
      // desktop nav = NAV_PRIMARY_RENDERED
      window.addEventListener(NAV_DATA.EVENTS.NAV_PRIMARY_RENDERED, handleNavRendered);
      // mobile/tablet nav = NAV_LOADED
      window.addEventListener(NAV_DATA.EVENTS.NAV_LOADED, handleNavRendered);
    }

    return (): void => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(NAV_DATA.EVENTS.NAV_PRIMARY_RENDERED, handleNavRendered);
        window.removeEventListener(NAV_DATA.EVENTS.NAV_LOADED, handleNavRendered);
      }
    };
  });

  if (isSelfRemoved) return null;

  return (
    <>
      <Container className={className} css={excludeDesktop}>
        <Primary>
          <SharedLoader maxWidth={133} />
          <SharedLoader maxWidth={64} />
        </Primary>
        {showSecondaryRow && (
          <Secondary>
            <SharedLoader maxWidth={133} />
            <SharedLoader maxWidth={133} />
          </Secondary>
        )}
      </Container>

      <Container className={className} css={desktopOnly}>
        {showPromoBar && (
          <Promo>
            <SharedLoader maxWidth={431} />
          </Promo>
        )}
        <Primary>
          <SharedLoader maxWidth={457} />
          <SharedLoader maxWidth={158} />
          <SharedLoader maxWidth={289} />
        </Primary>
        {showSecondaryRow && (
          <Secondary>
            <SharedLoader maxWidth={133} />
            <SharedLoader maxWidth={133} />
            <SharedLoader maxWidth={133} />
            <SharedLoader maxWidth={133} />
            <SharedLoader maxWidth={133} />
          </Secondary>
        )}
      </Container>
    </>
  );
};

export default PreauthNavSkeletonLoader;
